// NOTE: This file is an exact replica of "Campaign.js", except for line 39
// where the "page" is changed to "campaignLaunch"

import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Actions
import { getOrganization } from "../actions/content_actions";

//Styles
import "../static/styles/App.css";
import { makeStyles } from "@mui/styles";

//Helpers
import {
    getCampaignComponent,
} from "../helpers/functions";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    content: {
        width: "100%",
        minHeight: "calc(100vh - 90px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
}));

function CampaignLaunch(props) {
    const classes = useStyles();
    const { organization } = props;
    const campaignFromURL = props.match.params.campaign_key; // || getOrganizationForDomain()
    const [CampaignPage, setCampaignPage] = useState();

    useEffect(() => {
        if (campaignFromURL) {
            setCampaignPage(getCampaignComponent("campaignLaunch", campaignFromURL));
            //props.getOrganization(organizationFromURL)
        }
    }, []);

    return (
        <Suspense fallback={<></>}>
            {CampaignPage ? (
                <CampaignPage />
            ) : !campaignFromURL ? (
                <div className={classes.content}>
                    <Typography variant="h4">Page does not exist.</Typography>
                </div>
            ) : null}
        </Suspense>
    );
}

const mapStateToProps = (state) => {
    return {
        organization: state.content.organization,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrganization: (organization) =>
            dispatch(getOrganization(organization)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CampaignLaunch)
);
